import styled from 'styled-components';

const DigitalWrapperModal = styled.div``;

const DigitalWrapperModalBody = styled.div`
  background-color: var(--color-gray-50);
`;

export { DigitalWrapperModal, DigitalWrapperModalBody };
